import { render, staticRenderFns } from "./FundTestAccounts.vue?vue&type=template&id=50709cb3&scoped=true&"
import script from "./FundTestAccounts.vue?vue&type=script&lang=js&"
export * from "./FundTestAccounts.vue?vue&type=script&lang=js&"
import style0 from "./FundTestAccounts.vue?vue&type=style&index=0&id=50709cb3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50709cb3",
  null
  
)

export default component.exports